// src/components/Login.js
import React, { useState } from 'react';
import VelvetLogo from '../icons/VL_WordmarkOnly_Light.svg';
import '../styles/Login.css';

const Login = ({ authError, setAuthError }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingProvider, setLoadingProvider] = useState(null);

  const handleGoogleLogin = () => {
    setLoadingProvider('google');
    setIsLoading(true);
    setAuthError(null);
    const isProduction = window.location.hostname !== 'localhost';
    const loginUrl = isProduction
      ? `${window.location.origin}/auth/login`
      : 'http://localhost:5001/auth/login';
    window.location.href = loginUrl;
  };

  const handleMicrosoftLogin = () => {
    setLoadingProvider('microsoft');
    setIsLoading(true);
    setAuthError(null);
    const isProduction = window.location.hostname !== 'localhost';
    const loginUrl = isProduction
      ? `${window.location.origin}/auth/microsoft/login`
      : 'http://localhost:5001/auth/microsoft/login';
    window.location.href = loginUrl;
  };

  return (
    <div className="login-container">
      <div className="login-content">
        <img src={VelvetLogo} alt="Velvet" className="login-logo" />
        <h1>Welcome to Velvet,</h1>
        <p className="login-subtitle">Login or sign up with the account you already have!</p>

        {authError && (
          <div className="error-message">
            <p>
              {authError.split('\n').map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  {index < authError.split('\n').length - 1 && <br />}
                </React.Fragment>
              ))}
            </p>
            <button className="error-close" onClick={() => setAuthError(null)}>×</button>
          </div>
        )}

        <div className="login-buttons">
          <button
            className={`google-login-btn ${loadingProvider === 'google' ? 'loading' : ''}`}
            onClick={handleGoogleLogin}
            disabled={isLoading}
          >
            <div className="google-icon">
              <svg width="20" height="20" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
            </div>
            <span>{loadingProvider === 'google' ? 'Signing in...' : 'Log in with Google'}</span>
          </button>

          <button
            className={`microsoft-login-btn ${loadingProvider === 'microsoft' ? 'loading' : ''}`}
            onClick={handleMicrosoftLogin}
            disabled={isLoading}
          >
            <div className="microsoft-icon">
              <svg width="20" height="20" viewBox="0 0 21 21">
                <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
                <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
                <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
                <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
              </svg>
            </div>
            <span>{loadingProvider === 'microsoft' ? 'Signing in...' : 'Log in with Microsoft / Teams'}</span>
          </button>
        </div>

        <p className="login-visit-text">
          Visit <a href="https://myvelvet.agency" target="_blank" rel="noopener noreferrer">myvelvet.agency</a>
        </p>
      </div>

      <p className="login-footer-text">Velvet - Secure Access</p>
    </div>
  );
};

export default Login;
